<template>
  <div>
    <form
      id="articles-filters-form"
    >
      <div class="input-group-container">
        <label
          class="main-input-container"
          for="search-by-headline"
        >
          Search by headline:
          <input
            id="search-by-headline"
            class="main-input d-block mt-1"
            type="text"
            placeholder="Search for..."
            autocomplete="off"
            v-model="headLineSearch"
          >
        </label>
        <div class="sort-button-container align-self-end">
          <label
            class="sort-button"
            :class="{'selected-sort-button': sortBy === 'title-asc'}"
          >
            <input
              v-model="sortBy"
              type="radio"
              name="sort-articles-by"
              value="title-asc"
            >
            <span>
              <i class="fa-light fa-sort-alpha-down" />
            </span>
          </label>
        </div>
        <div class="sort-button-container align-self-end">
          <label
            class="sort-button"
            :class="{'selected-sort-button': sortBy === 'title-desc'}"
          >
            <input
              v-model="sortBy"
              type="radio"
              name="sort-articles-by"
              value="title-desc"
            >
            <span>
              <i class="fa-light fa-sort-alpha-up" />
            </span>
          </label>
        </div>
      </div>
      <div>
        <label>
          Filter by state:
        </label>
        <div class="input-group-container">
          <div class="main-input-container">
            <select
              v-model="selectedStates"
              id="filter-by-state"
              class="main-input"
              size="4"
              multiple
            >
              <option>Draft</option>
              <option>Approval</option>
              <option>Published</option>
              <option>Paused</option>
            </select>
          </div>
          <div class="sort-button-container">
            <label
              class="sort-button"
              :class="{'selected-sort-button': sortBy === 'state-asc'}"
            >
              <input
                v-model="sortBy"
                type="radio"
                name="sort-articles-by"
                value="state-asc"
              >
              <span>
                <i class="fa-light fa-sort-alpha-down" />
              </span>
            </label>
          </div>
          <div class="sort-button-container">
            <label
              class="sort-button"
              :class="{'selected-sort-button': sortBy === 'state-desc'}"
            >
              <input
                v-model="sortBy"
                type="radio"
                name="sort-articles-by"
                value="state-desc"
              >
              <span>
                <i class="fa-light fa-sort-alpha-up" />
              </span>
            </label>
          </div>
        </div>
      </div>
      <div class="input-group-container">
        <label class="main-input-container">
          Sort by update date:
        </label>
        <div class="sort-button-container">
          <label
            class="sort-button"
            :class="{'selected-sort-button': sortBy === 'updatedDate-asc'}"
          >
            <input
              v-model="sortBy"
              type="radio"
              name="sort-articles-by"
              value="updatedDate-asc"
            >
            <span>
              <i class="fa-light fa-sort-numeric-down" />
            </span>
          </label>
        </div>
        <div
          class="sort-button-container"
          :class="{'selected-sort-button': sortBy === 'updatedDate-desc'}"
        >
          <label class="sort-button">
            <input
              v-model="sortBy"
              type="radio"
              name="sort-articles-by"
              value="updatedDate-desc"
            >
            <span>
              <i class="fa-light fa-sort-numeric-up" />
            </span>
          </label>
        </div>
      </div>
      <button
        class="btn btn-primary"
        data-test="apply-filters-button"
        data-testid="apply-filters-button"
        type="submit"
        @click.prevent="applyFilters()"
        :disabled="allInputEmpty"
      >
        Apply Filters
      </button>
    </form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

function initialData() {
  return {
    headLineSearch: '',
    selectedStates: [],
    sortBy: '',
  };
}

export default {
  name: 'ArticlesFilters',
  props: {
    filtersApplied: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return initialData();
  },
  methods: {
    ...mapActions('content', [
      contentTypes.SET_FILTERS_QUERY,
      contentTypes.SET_CONTENT_ITEM_QUERY_PARAM,
      contentTypes.SET_SELECTED_ARTICLE_UUID,
      contentTypes.FETCH_ARTICLES,
    ]),
    getHeadLineSearchQuery() {
      const { headLineSearch } = this;
      return headLineSearch !== '' ? `&search=${encodeURIComponent(headLineSearch)}` : '';
    },
    getStateSort() {
      const { selectedStates } = this;
      return selectedStates.length !== 0 ? `&states=${selectedStates.join().toUpperCase()}` : '';
    },
    getSortByQuery() {
      const { sortBy } = this;
      return sortBy !== '' ? `&sort=${sortBy.split('-').join(',')}` : '';
    },
    getQuery() {
      return `${this.getHeadLineSearchQuery()}${this.getStateSort()}${this.getSortByQuery()}`;
    },
    async applyFilters() {
      this.$emit('filtersApplied', true);
      this.SET_FILTERS_QUERY(this.getQuery());
      this.SET_CONTENT_ITEM_QUERY_PARAM({
        search: this.headLineSearch ? encodeURIComponent(this.headLineSearch) : null,
        states: this.selectedStates ? this.selectedStates.join().toUpperCase() : null,
        sort: this.sortBy ? this.sortBy.split('-').join(',') : null,
      });
      await this.FETCH_ARTICLES();
      this.SET_SELECTED_ARTICLE_UUID('');
    },
    resetData(resetStore = false) {
      Object.assign(this.$data, initialData());
      if (resetStore) this.SET_FILTERS_QUERY('');
    },
  },
  computed: {
    ...mapState('content', [
      'filtersQuery',
    ]),
    allInputEmpty() {
      const {
        headLineSearch, sortBy, selectedStates,
      } = this;
      return headLineSearch === '' && sortBy === '' && selectedStates.length === 0;
    },
  },
  watch: {
    filtersQuery(newVal) {
      if (newVal === '') this.resetData();
    },
  },
  destroyed() {
    this.resetData(true);
  },
};
</script>
<style scoped lang="scss">

#articles-filters-form {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  // border-bottom: 2px solid hsla(191, 67%, 14%, 0.12);
  margin-bottom: 16px;
  > div > label {
    font-weight: bold;
    margin-bottom: 4px;
  }
}

.input-group-container{
  display: flex;
  gap: 8px;
}

.main-input-container {
  flex: 60%;
  .main-input {
    width: 100%;
  }
}
.sort-button-container {
  flex: 0 0 auto;
}

.sort-button {
  width: 40px;
  height: 40px;
  border: #ccc 1px solid;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.sort-button:hover {
  background-color: #eee;
}

.selected-sort-button {
  background-color: rgb(200, 223, 231);
  border: 1px solid darkblue;
}

input[type=radio] {
  display: none;
}

input[type=text] {
  display: block;
  height: 40px;
  padding: 0 12px;
  border: #aaa 1px solid;
  border-radius: 5px;
  &::placeholder {
    color: #ccc;
  }
}

#filter-by-state:focus, #search-by-headline:focus {
  outline-color: lightskyblue;
}

label {
  margin-bottom: 0px;
}

</style>
